import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';

const faqs = [
  {
    q: "桃子视频是什么？",
    a: "桃子视频是一个免费高清在线影视平台，提供涵盖红桃视频、黑桃视频、桃花视频、红杏视频、糖心视频、豆花视频、粉桃视频、白桃视频、紫桃视频、蓝桃视频等十大品类的影视资源。我们致力于为用户提供流畅、高清的观影体验，所有内容均经过严格筛选和分类。",
  },
  {
    q: "桃子视频的资源是否免费？",
    a: "是的，桃子视频所有影视资源均免费向用户开放。无需注册、无需付费，您可以直接在线观看我们平台上的所有电影、电视剧、综艺和纪录片等视频内容。",
  },
  {
    q: "视频播放卡顿怎么办？",
    a: "我们采用了先进的视频分发技术，确保大多数网络环境下都能流畅播放。如果您遇到卡顿问题，建议：1) 检查您的网络连接是否稳定；2) 尝试切换到较低的清晰度；3) 清理浏览器缓存后重试。桃子视频致力于为您提供不缓冲的流畅观影体验。",
  },
  {
    q: "如何找到我喜欢的视频？",
    a: "您可以通过首页的十大分类导航快速找到感兴趣的视频类型。每个分类都有详细的视频列表，支持分页浏览。您也可以使用搜索功能（即将上线）直接查找特定的视频内容。",
  },
  {
    q: "桃子视频的资源多久更新一次？",
    a: "我们每天都会更新最新的影视资源，确保用户能够第一时间观看到最新的电影、电视剧和综艺节目。您可以关注首页的「最新更新」板块，及时了解每日上新的内容。",
  },
];

const testimonials = [
  {
    name: "王先生",
    role: "资深影迷",
    content: "桃子视频的分类做得特别好，红桃的热血、黑桃的悬疑、桃花的浪漫，每类视频都很精准，找片子再也不用大海捞针了。播放也非常流畅！",
    rating: 5,
  },
  {
    name: "李女士",
    role: "家庭用户",
    content: "全家人都在用桃子视频，爷爷奶奶爱看豆花视频里的纪录片，孩子喜欢糖心视频的喜剧动画，我和老公追桃花视频的爱情剧，一个平台全搞定。",
    rating: 5,
  },
  {
    name: "张同学",
    role: "大学生",
    content: "高清不卡顿真的太棒了！宿舍网络不稳定的时候也能流畅观看。而且完全免费，对学生党太友好了。强烈推荐给身边所有人！",
    rating: 5,
  },
  {
    name: "陈先生",
    role: "影视从业者",
    content: "作为行业从业者，我特别关注视频平台的内容质量。桃子视频的片源画质和分类整理做得相当专业，每日更新的速度也很快，成为了我日常观影的首选平台。",
    rating: 5,
  },
];

export default function AboutPage() {
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [submitMessage, setSubmitMessage] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitStatus('success');
    setSubmitMessage('感谢您的留言，我们会尽快回复！');
    setContactForm({ name: '', email: '', message: '' });
    setTimeout(() => {
      setSubmitStatus('idle');
      setSubmitMessage('');
    }, 3000);
  };

  return (
    <>
      <SchemaOrg
        data={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.q,
            acceptedAnswer: { '@type': 'Answer', text: faq.a },
          })),
        }}
      />
      <SchemaOrg
        data={{
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.taozivideo.com/' },
            { '@type': 'ListItem', position: 2, name: '关于我们' },
          ],
        }}
      />
      <SchemaOrg
        data={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '关于我们 - 桃子视频',
          description: '桃子视频是一个免费高清在线影视平台，涵盖十大视频品类。了解我们的品牌故事、用户口碑和联系方式。',
          url: 'https://www.taozivideo.com/about',
        }}
      />
      <Navbar />
      <main className="pt-20 pb-10">
        {/* Breadcrumb */}
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto mb-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-500" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Brand Intro */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-primary-500">
              <i className="ri-play-circle-fill text-background-50 text-3xl"></i>
            </div>
            <h1 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 mb-4">
              关于桃子视频
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              桃子视频成立于2024年，是一个致力于为用户提供免费高清在线观影体验的影视平台。我们以"色彩分类"为核心理念，将海量影视资源按照不同的情感色调分为十大品类——红桃的热血、黑桃的神秘、桃花的浪漫、红杏的青春、糖心的甜蜜、豆花的清新、粉桃的可爱、白桃的纯粹、紫桃的奇幻、蓝桃的深邃，让每一位用户都能找到属于自己的观影心情。
            </p>
          </div>
        </section>

        {/* Stats */}
        <section className="w-full px-4 md:px-6 py-10 md:py-12">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {[
                { num: '10+', label: '视频分类' },
                { num: '5万+', label: '视频资源' },
                { num: '1000万+', label: '月活用户' },
                { num: '99.9%', label: '播放流畅率' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-xl bg-background-100">
                  <div className="text-2xl md:text-3xl font-bold font-heading text-primary-500 mb-1">
                    {stat.num}
                  </div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 text-center mb-8">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {testimonials.map((t) => (
                <div key={t.name} className="p-5 rounded-xl bg-background-50">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{t.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-xs font-semibold text-primary-700">{t.name[0]}</span>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
              <div>
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-4">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-600 mb-6 leading-relaxed">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们，或者直接填写右侧的表单，我们的团队会尽快回复您。
                </p>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">电子邮箱</div>
                      <div className="text-sm text-foreground-600">contact@taozivideo.com</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                      <i className="ri-phone-line text-primary-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">客服电话</div>
                      <div className="text-sm text-foreground-600">400-888-0000</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                      <i className="ri-map-pin-line text-primary-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">公司地址</div>
                      <div className="text-sm text-foreground-600">北京市朝阳区建国路88号SOHO现代城A座</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                      <i className="ri-time-line text-primary-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">工作时间</div>
                      <div className="text-sm text-foreground-600">周一至周日 9:00 - 21:00</div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <form onSubmit={handleSubmit} className="bg-background-100 rounded-xl p-6" data-readdy-form="">
                  <h3 className="text-base font-semibold text-foreground-900 mb-4">发送消息</h3>
                  {submitStatus === 'success' && (
                    <div className="mb-4 p-3 rounded-lg bg-accent-100 text-accent-800 text-sm">
                      {submitMessage}
                    </div>
                  )}
                  {submitStatus === 'error' && (
                    <div className="mb-4 p-3 rounded-lg bg-red-100 text-red-800 text-sm">
                      {submitMessage}
                    </div>
                  )}
                  <div className="space-y-4">
                    <div>
                      <label className="block text-xs font-medium text-foreground-700 mb-1">
                        姓名
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={contactForm.name}
                        onChange={(e) => setContactForm((prev) => ({ ...prev, name: e.target.value }))}
                        className="w-full px-3 py-2 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 outline-none focus:border-primary-400 transition-colors"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-foreground-700 mb-1">
                        邮箱
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={contactForm.email}
                        onChange={(e) => setContactForm((prev) => ({ ...prev, email: e.target.value }))}
                        className="w-full px-3 py-2 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 outline-none focus:border-primary-400 transition-colors"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-foreground-700 mb-1">
                        留言内容
                      </label>
                      <textarea
                        name="message"
                        value={contactForm.message}
                        onChange={(e) => {
                          if (e.target.value.length <= 500) {
                            setContactForm((prev) => ({ ...prev, message: e.target.value }));
                          }
                        }}
                        rows={4}
                        className="w-full px-3 py-2 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 outline-none focus:border-primary-400 transition-colors resize-none"
                        required
                      />
                      <p className="text-xs text-foreground-400 mt-1 text-right">
                        {contactForm.message.length}/500
                      </p>
                    </div>
                    <div className="form-hp-wrap">
                      <label htmlFor="phone_alt_form">备用联系方式</label>
                      <input type="text" id="phone_alt_form" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                    </div>
                    <button
                      type="submit"
                      className="w-full py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      发送消息
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 text-center mb-8">
              常见问题
            </h2>
            <div className="space-y-3">
              {faqs.map((faq, idx) => (
                <details
                  key={idx}
                  className="group bg-background-50 rounded-xl overflow-hidden"
                >
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                    <span className="text-sm font-medium text-foreground-900 pr-4">
                      {faq.q}
                    </span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}